import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Container,
  Drawer,
  Grid2,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import BannerImage from "../assets/images/hero-banner.png";
import BannerImage2 from "../assets/images/banner-image-2.jpg";
import BannerImage3 from "../assets/images/banner-image-3.jpg";
import MobileBannerImage from "../assets/images/mobile-banner.png";
import TacoBell from "../assets/images/taco-bell.png";
import MacD from "../assets/images/McDonald.png";
import haldirams from "../assets/images/haldirams.png";
import subway from "../assets/images/subway.png";
import bannerLeftImage from "../assets/images/banner-left-image.png";

import testi1 from "../assets/images/testi-1.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRight,
  faChevronDown,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import CuisineCard from "../components/common/CuisineCard";
// import TestimonialCard from "../components/common/TestimonialCard";
import VendorCard from "../components/common/VendorCard";
import productService from "../services/productService";
import vendorService from "../services/vendorService";
import TestimonialCard from "../components/common/TestimonialCard";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import VendorCardSkeleton from "../components/common/VendorCardSkeleton";
import { handleErrors } from "../utils/error-handler";
import { ErrorHandlingDesign } from "../components/common/errorHandlingDesign";

const HomePage = () => {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);
  const [slideFrom, setSlideFrom] = useState("right");
  const [isCategoryLoading, setIsCategoryLoading] = useState(true);
  const [categoryList, setCategoryList] = useState([]);
  const [showAllVendors, setShowAllVendors] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isVendorLoading, setIsVendorLoading] = useState(true);
  const [vendorList, setVendorList] = useState([]);
  const [categoryError, setCategoryError] = useState(null);
  const [vendorError, setVendorError] = useState(null);
  const [subCategoryError, setSubCategoryError] = useState(null);
  const [isSubCategoryLoading, setIsSubCategoryLoading] = useState(true);
  const [subCategoryList, setSubCategoryList] = useState([]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const [open, setOpen] = useState(false);
  const toggleDrawer = (newOpen, categoryId) => () => {
    const category = categoryList.find((c) => c.id === categoryId);
    setSelectedCategory(category); // ✅ store selected category
    getSubCategoryData(categoryId);
    setOpen(newOpen);
  };

  const [isMobile, setIsMobile] = useState(false);

  const sectionOneRef = useRef(null);
  const sectionTwoRef = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };
  const visibleVendors = showAllVendors ? vendorList : vendorList.slice(0, 6);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
      if (window.innerWidth < 640) {
        setSlideFrom("bottom");
      }
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize); // Update on window resize

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getSubCategoryData = async (categoryId) => {
    setIsSubCategoryLoading(true);
    setSubCategoryError(null);
    try {
      const data = await productService.getProductSubCategory(categoryId);
      setSubCategoryList(data);
    } catch (error) {
      setSubCategoryError("Failed to load sub-categories.");
    } finally {
      setIsSubCategoryLoading(false);
    }
  };
  //getProductCategoryData data is update
  useEffect(() => {
    const getProductCategoryData = async () => {
      setIsCategoryLoading(true);
      setCategoryError(null);
      try {
        const data = await productService.getProductCategory();
        setCategoryList(data);
      } catch (error) {
        setCategoryError("Failed to load categories.");
      } finally {
        setIsCategoryLoading(false);
      }
    };

    const getVendorData = async () => {
      setIsVendorLoading(true);
      setVendorError(null);
      try {
        const data = await vendorService.getVendors();
        setVendorList(data);
      } catch (error) {
        setVendorError("Failed to load vendors.");
      } finally {
        setIsVendorLoading(false);
      }
    };

    getProductCategoryData();
    getVendorData();
  }, []);
  // Category card Skeleton
  const CuisineCardSkeleton = () => (
    <div className="cuisine-card">
      <div className="cuisine-title text-med-emphasis">
        <Skeleton width={100} height={20} />
      </div>
      <div className="cuisine-img">
        <Skeleton height={100} />
      </div>
    </div>
  );
  // Sub-Category card Skeleton
  const SubCategorySkeleton = () => (
    <div className="product-list-item">
      <div className="image">
        <Skeleton height={80} width={80} />
      </div>
      <p>
        <Skeleton width={80} />
      </p>
    </div>
  );

  const testimonials = [
    {
      name: "Kritika Thakur",
      position: "Sales Head, Taco Bell",
      feedback:
        "With Swiggy's wide range of packaging options, we can ensure every dish, from steaming hot meals to chilled desserts, is delivered in perfect condition every time!",
      userImage: testi1,
      brandImage: TacoBell,
    },
    {
      name: "Karanjeet Singh",
      position: "Director, Subway",
      feedback:
        "The variety of packaging options available through Swiggy has allowed us to customize our delivery experience. Whether it's hot meals or cold desserts, we have the perfect solution for every dish.",
      userImage: testi1,
      brandImage: subway,
    },
    {
      name: "Harshita Khurana",
      position: "Sales Head, Haldirams",
      feedback:
        "Swiggy's packaging options let us tailor our delivery—hot meals or cold desserts, we've got the perfect fit for every dish!",
      userImage: testi1,
      brandImage: haldirams,
    },
    {
      name: "Sarthak Prashar",
      position: "Sales VP, Mc Donalds",
      feedback:
        "Swiggy's extensive range of packaging options allows us to deliver every dish just right—whether it’s a piping hot meal or a refreshingly cold dessert, we’ve got the perfect solution to match every need!",
      userImage: testi1,
      brandImage: MacD,
    },
    {
      name: "Karanjeet Singh",
      position: "Director, Subway",
      feedback:
        "The variety of packaging options available through Swiggy has allowed us to customize our delivery experience. Whether it's hot meals or cold desserts, we have the perfect solution for every dish.",
      userImage: testi1,
      brandImage: subway,
    },
    {
      name: "Harshita Khurana",
      position: "Sales Head, Haldirams",
      feedback:
        "Swiggy's packaging options let us tailor our delivery—hot meals or cold desserts, we've got the perfect fit for every dish!",
      userImage: testi1,
      brandImage: haldirams,
    },
  ];

  return (
    <>
      <section className="banner-section">
        <Swiper
          pagination={{ clickable: true }}
          slidesPerView={1}
          centeredSlides={true}
          loop
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          modules={[Autoplay, Pagination]}
          navigation={{ clickable: true }}
        >
          <SwiperSlide className={`home-banner-slide-1`}>
            <div className="banner-image">
              <img
                src={BannerImage}
                alt=""
                className="desktop-banner home-banner"
              />
              <img
                src={MobileBannerImage}
                alt=""
                className="mobile-banner home-banner"
              />
              <Container className="xs-position-relative">
                <div className="banner-content">
                  <h1 className="text-white-highest-emphasis">
                    All Your Packaging Needs, Solved
                  </h1>
                  <p className="text-white-high-emphasis">
                    Expert best practices, cuisine-specific insights, and
                    trusted vendors—all in one place.
                  </p>
                  <button
                    className="btn btn-orange"
                    onClick={() => scrollToSection(sectionOneRef)}
                  >
                    Explore Solutions
                  </button>
                </div>
              </Container>
            </div>
          </SwiperSlide>
          <SwiperSlide className={`home-banner-slide-2`}>
            <div className="banner-image">
              <img
                src={BannerImage2}
                alt=""
                className="desktop-banner home-banner"
              />
              <img
                src={BannerImage2}
                alt=""
                className="mobile-banner home-banner"
              />
              <Container className="xs-position-relative">
                <div className="banneer-content-wrap">
                  <div className="banner-content">
                    <h1 className="text-white-highest-emphasis">
                      Stand Out With Sustainable Packaging
                    </h1>
                    <p className="text-white-high-emphasis">
                      Innovative, eco-friendly solutions from vendors across
                      India
                    </p>
                    <button
                      className="btn btn-black"
                      onClick={() => scrollToSection(sectionTwoRef)}
                    >
                      Meet Our Vendors
                    </button>
                  </div>
                  <div className="banner-left-image">
                    <img src={bannerLeftImage} alt="" />
                  </div>
                </div>
              </Container>
            </div>
          </SwiperSlide>
          <SwiperSlide className={`home-banner-slide-3`}>
            <div className="banner-image">
              <img
                src={BannerImage3}
                alt=""
                className="desktop-banner home-banner"
              />
              <img
                src={BannerImage3}
                alt=""
                className="mobile-banner home-banner"
              />
              <Container className="xs-position-relative">
                <div className="banner-content">
                  <h1 className="text-highest-emphasis">
                    Achieve Your Sustainability Goals
                  </h1>
                  <p className="text-high-emphasis">
                    Eco-friendly packaging options that align with your brand
                    values
                  </p>
                  <Link className="btn btn-orange" to={"sustainability"}>
                    Discover Sustainable Options
                  </Link>
                </div>
              </Container>
            </div>
          </SwiperSlide>
        </Swiper>
      </section>

      <section
        className="explore-package"
        ref={sectionOneRef}
        id="explore-solutions"
      >
        <Container>
          <div className="section-title">
            <h2 className="text-center">
              <span className="gradient-text decorated-title">
                Explore Packaging by Cuisine
              </span>
            </h2>
          </div>

          <Drawer
            className="cuisine-sidebar"
            anchor={slideFrom}
            open={open}
            onClose={toggleDrawer(false)}
          >
            <div
              className="close-sidebar cursor-pointer"
              onClick={toggleDrawer(false)}
            >
              <span className="close-btn">
                <FontAwesomeIcon icon={faXmark} />
              </span>
            </div>
            <div className="sidebar-content">
              <div className="title">
                <h3>
                  {selectedCategory?.categoryName || <Skeleton width={150} />}
                </h3>
                <p>{`Select from these ${subCategoryList.length} Dishes`}</p>
              </div>
              <div className="category-product-list">
                {subCategoryError ? (
                  <ErrorHandlingDesign errorMessage={subCategoryError} />
                ) : isSubCategoryLoading ? (
                  Array.from({ length: 5 }).map((_, index) => (
                    <SubCategorySkeleton key={index} />
                  ))
                ) : (
                  subCategoryList.map((subCategory) => (
                    <Link
                      key={subCategory.id}
                      to={`${subCategory.categoryUrl}/${subCategory.subCategoryURL}-${subCategory.id}`}
                      state={{
                        subCategoryUrl: subCategory.subCategoryURL,
                        id: subCategory.id,
                        categoryUrl: subCategory.categoryUrl,
                      }}
                    >
                      <div className="product-list-item">
                        <div className="image">
                          <img src={subCategory.imageURL} alt="" />
                        </div>
                        <p>{subCategory.subCategoryName}</p>
                      </div>
                    </Link>
                  ))
                )}
              </div>
            </div>
          </Drawer>

          {categoryError ? (
            <ErrorHandlingDesign errorMessage={categoryError} />
          ) : isCategoryLoading ? (
            isMobile ? (
              <div className="cuisine-card-wrap-mobile">
                {Array.from({ length: 5 }).map((_, index) => (
                  <CuisineCardSkeleton key={index} />
                ))}
              </div>
            ) : (
              <div className="cuisine-slider-wrap">
                <button className="custom-prev slider-arrow">
                  <FontAwesomeIcon icon={faArrowLeft} />
                </button>
                <button className="custom-next slider-arrow">
                  <FontAwesomeIcon icon={faArrowRight} />
                </button>
                <Swiper
                  modules={[Pagination, Navigation]}
                  pagination={{ clickable: true }}
                  slidesPerView={"auto"}
                  spaceBetween={20}
                  navigation={{
                    nextEl: ".custom-next",
                    prevEl: ".custom-prev",
                    clickable: true,
                  }}
                  className="cuisine-slider"
                >
                  {Array.from({ length: 5 }).map((_, index) => (
                    <SwiperSlide key={index}>
                      <CuisineCardSkeleton />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            )
          ) : isMobile ? (
            <div className="cuisine-card-wrap-mobile">
              {categoryList.map((cuisine) => (
                <CuisineCard
                  key={cuisine.id}
                  name={cuisine.categoryName}
                  image={cuisine.imageURL}
                  onClick={toggleDrawer(true, cuisine.id)}
                />
              ))}
            </div>
          ) : (
            <div className="cuisine-slider-wrap">
              <button className="custom-prev slider-arrow">
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
              <button className="custom-next slider-arrow">
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
              <Swiper
                modules={[Pagination, Navigation]}
                pagination={{ clickable: true }}
                slidesPerView={"auto"}
                spaceBetween={20}
                navigation={{
                  nextEl: ".custom-next",
                  prevEl: ".custom-prev",
                  clickable: true,
                }}
                className="cuisine-slider"
              >
                {categoryList.map((cuisine) => (
                  <SwiperSlide key={cuisine.id}>
                    <CuisineCard
                      name={cuisine.categoryName}
                      image={cuisine.imageURL}
                      onClick={toggleDrawer(true, cuisine.id)}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          )}
        </Container>
      </section>

      <section
        className="explore-vendors"
        ref={sectionTwoRef}
        id="explore-vendors"
      >
        <Container>
          <div className="section-title">
            <h2 className="text-center">
              <span className="gradient-text decorated-title">
                Explore Packaging by Vendors
              </span>
            </h2>
          </div>
          {vendorError ? (
            <ErrorHandlingDesign errorMessage={vendorError} />
          ) : isVendorLoading ? (
            <Grid2 container spacing={{ xs: 1, md: "20px" }}>
              {Array.from({ length: 6 }).map((_, index) => (
                <Grid2 key={index} size={{ xs: 6, md: 6, lg: 4 }}>
                  <VendorCardSkeleton />
                </Grid2>
              ))}
            </Grid2>
          ) : (
            <Grid2 container spacing={{ xs: 1, md: "20px" }}>
              {visibleVendors.map((vendor, index) => (
                <Grid2 key={index} size={{ xs: 6, md: 6, lg: 4 }}>
                  <Link
                    to={`${vendor.vendorUrl}-${vendor?.id}`}
                    state={{
                      vendorUrl: vendor?.vendorUrl,
                      id: vendor?.id,
                    }}
                    className="text-decoration-none"
                  >
                    <VendorCard vendor={vendor} />
                  </Link>
                </Grid2>
              ))}

              {vendorList.length > 5 && (
                <Grid2 size={12} className="text-center mt-24">
                  <button
                    className="btn btn-orange-outlined rounded"
                    onClick={() => setShowAllVendors(!showAllVendors)}
                  >
                    {showAllVendors ? "Show Less" : "Show More"}
                  </button>
                </Grid2>
              )}
            </Grid2>
          )}
        </Container>
      </section>

      <section className="testimonial-section">
        <Container>
          <div className="section-title">
            <h2 className="text-center">Stories from our Partners</h2>
          </div>
        </Container>
        <Swiper
          slidesPerView={"auto"}
          spaceBetween={20}
          centeredSlides={true}
          loop
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
          className="testimonial-slider"
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <TestimonialCard testimonial={testimonial} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className="faq-section">
        <Container>
          <div className="section-title">
            <h2 className="text-center">Frequently Asked Questions</h2>
          </div>
          <div className="faq-wrapper">
            <Accordion
              expanded={expanded === "panel1"}
              onChange={handleChange("panel1")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                What type of packaging solutions do Packaging Vendors offer?
              </AccordionSummary>
              <AccordionDetails className="text-low-emphasis">
                Packaging Vendors offer a wide range of packaging options for
                different cuisines and dishes, including containers, boxes,
                wraps, cups, cutlery, and bags. Both regular and sustainable
                packaging options are available.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel2"}
              onChange={handleChange("panel2")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                How can I order packaging ?
              </AccordionSummary>
              <AccordionDetails className="text-low-emphasis">
                You can browse available packaging options on the platform,
                compare vendors, and raise an order or enquiry through the
                website. The packaging vendor will contact you within 2 days of
                raising the enquiry.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel4"}
              onChange={handleChange("panel4")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
                aria-controls="panel4-content"
                id="panel4-header"
              >
                What is the delivery turnaround time (TAT)?
              </AccordionSummary>
              <AccordionDetails className="text-low-emphasis">
                Delivery TAT depends on the vendor and your location, but it
                typically ranges from 5 to 7 business days.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel3"}
              onChange={handleChange("panel3")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
                aria-controls="panel3-content"
                id="panel3-header"
              >
                How is pricing determined for packaging products?
              </AccordionSummary>
              <AccordionDetails className="text-low-emphasis">
                Pricing is set by each vendor and may vary depending on
                material, quantity, and customization. Bulk discounts may apply.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel5"}
              onChange={handleChange("panel5")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
                aria-controls="panel5-content"
                id="panel5-header"
              >
                Can I customize packaging with my restaurant's branding?
              </AccordionSummary>
              <AccordionDetails className="text-low-emphasis">
                Yes, several vendors offer customization options including logo
                printing and custom sizes. You can request this while raising a
                query.
              </AccordionDetails>
            </Accordion>
            <div className="contact-info text-center">
              <p className="text-low-emphasis">
                Still got a question? You can email us at{" "}
                <Link
                  to={"mailto:partnersupport@swiggy.in"}
                  className="text-orange"
                >
                  partnersupport@swiggy.in
                </Link>
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default HomePage;
